import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.choices = this.selectTargets.map((selectElement) => {
      const maxItemCount = selectElement.dataset.maxItemCount || -1;
      const placeholderValue =
        selectElement.dataset.placeholderValue || "Select options...";

      return new Choices(selectElement, {
        removeItemButton: true,
        searchEnabled: true,
        placeholder: true,
        allowHTML: false,
        position: "bottom",
        duplicateItemsAllowed: false,
        maxItemCount: parseInt(maxItemCount, 10),
        placeholderValue: placeholderValue,
      });
    });
  }

  disconnect() {
    if (this.choices) {
      this.choices.forEach((choiceInstance) => choiceInstance.destroy());
    }
  }
}
